import { render, staticRenderFns } from "./wareArea.vue?vue&type=template&id=2ceac81c"
import script from "./wareArea.vue?vue&type=script&lang=js"
export * from "./wareArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports